__turbopack_context__.v({
  "chevron": "_row-module__e2cBtq__chevron",
  "content": "_row-module__e2cBtq__content",
  "item": "_row-module__e2cBtq__item",
  "itemActive": "_row-module__e2cBtq__itemActive",
  "list": "_row-module__e2cBtq__list",
  "spin": "_row-module__e2cBtq__spin",
  "spinner": "_row-module__e2cBtq__spinner",
  "thumbnail": "_row-module__e2cBtq__thumbnail",
  "thumbnailIcon": "_row-module__e2cBtq__thumbnailIcon",
  "thumbnailImg": "_row-module__e2cBtq__thumbnailImg",
  "title": "_row-module__e2cBtq__title",
});
